import { gql } from "@apollo/client"

export const GET_TOTAL_ACTIVE_STATES_QUERY = gql`
  query getTotalActiveStates($data: TotalActiveInput!) {
    widgets {
      getTotalActiveStates(data: $data) {
        active
        total
      }
    }
  }
`
